import { AutomationPlatform } from '@/types';
import {
  IconBrandGithub,
  IconCloudQuestion,
  IconClock,
  IconWorld,
} from '@tabler/icons-react';

import IconApi from '@/assets/svgs/api.svg?react';
import IconArgoCD from '@/assets/svgs/argocd.svg?react';
import IconJenkins from '@/assets/svgs/jenkins.svg?react';
import IconCopado from '@/assets/svgs/copado.svg?react';
import IconOctopusDeploy from '@/assets/svgs/octopusdeploy.svg?react';
import IconAzureDevOps from '@/assets/svgs/azure-devops.svg?react';
import IconBamboo from '@/assets/svgs/bamboo.svg?react';

export const ENVIRONMENTS = [
  'Development',
  'Production',
  'Staging',
  'Sandbox',
  'UserAcceptanceTesting',
  'QualityAssurance',
  'Integration',
  'LoadTesting',
  'DisasterRecovery',
  'NonProduction',
];

export const ENVIRONMENT_ACRONYMS = {
  development: 'dev',
  nonproduction: 'non',
  production: 'prd',
  staging: 'stg',
  sandbox: 'tst',
  loadtesting: 'prf',
  disasterrecovery: 'dre',
  integration: 'int',
  useracceptancetesting: 'uat',
  qualityassurance: 'qae',
  all: 'all',
};

export const ORR_PLATFORMS = {
  [AutomationPlatform.ORR_PORTAL]: {
    label: 'ORR Portal',
    icon: IconWorld,
  },
  [AutomationPlatform.SCHEDULER]: {
    label: 'Scheduled',
    icon: IconClock,
  },
  [AutomationPlatform.SITE_COMPLIANCE_PORTAL]: {
    label: 'Site Compliance Portal',
    icon: IconWorld,
  },
  [AutomationPlatform.ADO]: {
    label: 'Azure DevOps',
    icon: IconAzureDevOps,
  },
  [AutomationPlatform.BAMBOO]: {
    label: 'Bamboo',
    icon: IconBamboo,
  },
  [AutomationPlatform.COMFORMANCE]: {
    label: 'API',
    icon: IconApi,
  },
  [AutomationPlatform.NETBOX]: {
    label: 'NetBox',
    icon: IconApi,
  },
  [AutomationPlatform.GITHUB_ACTIONS]: {
    label: 'Github Actions',
    icon: IconBrandGithub,
  },
  [AutomationPlatform.ARGO_CD]: {
    label: 'Argo CD',
    icon: IconArgoCD,
  },
  [AutomationPlatform.JENKINS]: {
    label: 'Jenkins',
    icon: IconJenkins,
  },
  [AutomationPlatform.COPADO]: {
    label: 'Copado',
    icon: IconCopado,
  },
  [AutomationPlatform.OCTOPUS_DEPLOY]: {
    label: 'Octopus Deploy',
    icon: IconOctopusDeploy,
  },
  [AutomationPlatform.UNKNOWN]: {
    label: 'Unknown',
    icon: IconCloudQuestion,
  },
};
